module.exports = __webpack_public_path__ + "static/Harish_Closepet-b275be84ba46c47fddf30288c8dba85b.jpg";